import { useEffect, useState } from 'react';
import {
	useQuoteDispatch,
	useQuoteState,
} from '../../../../../stateProviders/QuoteStateProvider';
import { useApi } from '../../../../../hooks/useApi';
import { useGlobalState } from '../../../../../stateProviders/GlobalStateProvider';
import { LogisticCostsPermit } from '../../../../../types/api/LogisticCosts';
import React from 'react';
import { Select, MenuItem, Typography, Box } from '@mui/material';

export const PermitSelection = () => {
	const quoteDispatch = useQuoteDispatch();
	const api = useApi();
	const globalState = useGlobalState();
	const [permits, setPermits] = useState<LogisticCostsPermit[]>([]);
	const [loading, setLoading] = useState(true);
	const quoteState = useQuoteState();
	const [apiError, setApiError] = useState({
		errored: false,
		error: { message: '' },
		errorType: '',
	});

	useEffect(() => {
		(async () => {
			const permits = await api.logisticCosts.getPermits({
				companyId: globalState.company?._id,
			});

			if ('errored' in permits) {
				setApiError(permits);
				setLoading(false);
				return;
			}

			setPermits(permits);
			setApiError({ errored: false, error: { message: '' }, errorType: '' });
			setLoading(false);
		})();
	}, []);
	const handlePermitChange = (permitId: string) => {
		if (!permitId) {
			quoteDispatch({
				selectedPermit: '',
				selectedPermitCost: 0,
			});
			return;
		}

		const selectedPermit = permits.find((p) => p._id === permitId);
		if (selectedPermit) {
			const permitAmount = Number(selectedPermit.permitAmount) || 0;
			quoteDispatch({
				selectedPermit: permitId,
				selectedPermitCost: permitAmount,
			});
		}
	};

	if (loading) {
		return (
			<Box sx={{ minWidth: 180 }}>
				<Select value="" displayEmpty fullWidth disabled>
					<MenuItem value="">Loading...</MenuItem>
				</Select>
			</Box>
		);
	}

	if (apiError.errored) {
		return (
			<Box sx={{ p: 2 }}>
				<Typography color="error" variant="h6">
					API Error:
				</Typography>
				<Typography color="error">{apiError.error.message}</Typography>
			</Box>
		);
	}

	return (
		<Box sx={{ minWidth: 180 }}>
			<Select
				value={quoteState.selectedPermit || ''}
				fullWidth
				variant="outlined"
				displayEmpty
				onChange={(e) => handlePermitChange(e.target.value)}
			>
				<MenuItem value="">No Permit Required</MenuItem>
				{permits.map((permit) => (
					<MenuItem key={permit._id} value={permit._id}>
						{permit.permitName}
					</MenuItem>
				))}
			</Select>
		</Box>
	);
};
